(function (root, factory) {
  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (root) {
    root.VikisCalculatorCore = api;
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  var CATEGORY_RATES = {
    dog: [
      { id: 'dog-raw-top', name: 'Raw — Top Choice', rate: 6.5 },
      { id: 'dog-raw-budget', name: 'Raw — Budget Choice', rate: 4.8 },
      { id: 'dog-cooked', name: 'Gently Cooked', rate: 7.5 }
    ],
    cat: [
      { id: 'cat-raw', name: 'Raw', rate: 6.5 },
      { id: 'cat-cooked', name: 'Gently Cooked', rate: 7.5 }
    ]
  };

  var DOG_FACTORS = {
    low: { small: 0.025, large: 0.02 },
    moderate: { small: 0.03, large: 0.025 },
    high: { small: 0.035, large: 0.03 }
  };

  var CONDITION_ADJUSTMENTS = {
    underweight: 0.005,
    optimum: 0,
    unsure: 0,
    overweight: -0.005
  };

  var PORTION_INCREMENT_GRAMS = 5;
  var MINIMUM_PACKAGE_GRAMS = 90;
  var MINIMUM_BUDGET_PACKAGE_GRAMS = 300;
  var OWNER_PRICES = {
    'dog-raw-top': {
      90: { full: 28, mix: 15 },
      105: { full: 32, mix: 17 },
      120: { full: 35, mix: 18 },
      135: { full: 38, mix: 20 },
      150: { full: 40, mix: 21 },
      165: { full: 44, mix: 23 },
      180: { full: 45, mix: 24 },
      195: { full: 48, mix: 25 },
      210: { full: 51, mix: 26 },
      225: { full: 54, mix: 28 },
      240: { full: 57, mix: 29 },
      250: { full: 59, mix: 30 },
      255: { full: 60, mix: 31 },
      270: { full: 63, mix: 32 },
      285: { full: 66, mix: 34 },
      300: { full: 69, mix: 35 },
      325: { full: 73, mix: 37 },
      350: { full: 78, mix: 40 },
      375: { full: 83, mix: 42 },
      400: { full: 88, mix: 45 },
      425: { full: 93, mix: 47 },
      450: { full: 99, mix: 50 },
      475: { full: 103, mix: 52 },
      500: { full: 109, mix: 55 },
      525: { full: 112, mix: 57 },
      550: { full: 117, mix: 59 },
      575: { full: 122, mix: 62 },
      600: { full: 127, mix: 64 },
      625: { full: 132, mix: 67 },
      650: { full: 137, mix: 69 },
      675: { full: 142, mix: 72 },
      700: { full: 147, mix: 74 },
      725: { full: 151, mix: 76 },
      750: { full: 156, mix: 79 },
      775: { full: 161, mix: 81 },
      800: { full: 166, mix: 84 },
      825: { full: 171, mix: 86 },
      850: { full: 176, mix: 89 },
      875: { full: 181, mix: 91 },
      900: { full: 186, mix: 94 },
      925: { full: 190, mix: 96 },
      950: { full: 195, mix: 98 },
      975: { full: 200, mix: 101 },
      1000: { full: 205, mix: 103 },
      1025: { full: 210, mix: 106 },
      1050: { full: 215, mix: 108 },
      1075: { full: 220, mix: 111 },
      1100: { full: 225, mix: 113 },
      1125: { full: 229, mix: 115 },
      1150: { full: 234, mix: 118 },
      1175: { full: 239, mix: 120 },
      1200: { full: 244, mix: 123 },
      1225: { full: 249, mix: 125 },
      1250: { full: 254, mix: 128 },
      1275: { full: 259, mix: 130 },
      1300: { full: 264, mix: 133 },
      1325: { full: 268, mix: 135 },
      1350: { full: 273, mix: 137 },
      1375: { full: 278, mix: 140 },
      1400: { full: 283, mix: 142 },
      1425: { full: 288, mix: 145 },
      1450: { full: 293, mix: 147 },
      1475: { full: 298, mix: 150 },
      1500: { full: 303, mix: 152 }
    },
    'dog-raw-budget': {
      300: { full: 53, mix: 27 },
      325: { full: 57, mix: 29 },
      350: { full: 60, mix: 31 },
      375: { full: 64, mix: 33 },
      400: { full: 68, mix: 35 },
      425: { full: 71, mix: 36 },
      450: { full: 75, mix: 38 },
      475: { full: 78, mix: 40 },
      500: { full: 82, mix: 42 },
      525: { full: 86, mix: 44 },
      550: { full: 89, mix: 45 },
      575: { full: 93, mix: 47 },
      600: { full: 96, mix: 49 },
      625: { full: 100, mix: 51 },
      650: { full: 104, mix: 53 },
      675: { full: 107, mix: 54 },
      700: { full: 111, mix: 56 },
      725: { full: 114, mix: 58 },
      750: { full: 118, mix: 60 },
      775: { full: 122, mix: 62 },
      800: { full: 125, mix: 63 },
      825: { full: 129, mix: 65 },
      850: { full: 132, mix: 67 },
      875: { full: 136, mix: 69 },
      900: { full: 140, mix: 71 },
      925: { full: 143, mix: 72 },
      950: { full: 147, mix: 74 },
      975: { full: 150, mix: 76 },
      1000: { full: 154, mix: 78 },
      1025: { full: 158, mix: 80 },
      1050: { full: 161, mix: 81 },
      1075: { full: 165, mix: 83 },
      1100: { full: 168, mix: 85 },
      1125: { full: 172, mix: 87 },
      1150: { full: 176, mix: 89 },
      1175: { full: 179, mix: 90 },
      1200: { full: 183, mix: 92 },
      1225: { full: 186, mix: 94 },
      1250: { full: 190, mix: 96 },
      1275: { full: 194, mix: 98 },
      1300: { full: 197, mix: 99 },
      1325: { full: 201, mix: 101 },
      1350: { full: 204, mix: 103 },
      1375: { full: 208, mix: 105 },
      1400: { full: 212, mix: 107 },
      1425: { full: 215, mix: 108 },
      1450: { full: 219, mix: 110 },
      1475: { full: 222, mix: 112 },
      1500: { full: 226, mix: 114 }
    },
    'dog-cooked': {
      90: { full: 31, mix: 17 },
      105: { full: 36, mix: 19 },
      120: { full: 40, mix: 21 },
      135: { full: 43, mix: 22 },
      150: { full: 45, mix: 23 },
      165: { full: 48, mix: 25 },
      180: { full: 51, mix: 26 },
      195: { full: 54, mix: 28 },
      210: { full: 57, mix: 29 },
      225: { full: 61, mix: 31 },
      240: { full: 64, mix: 33 },
      250: { full: 67, mix: 34 },
      255: { full: 68, mix: 35 },
      270: { full: 71, mix: 36 },
      285: { full: 74, mix: 38 },
      300: { full: 79, mix: 40 },
      325: { full: 83, mix: 42 },
      350: { full: 89, mix: 45 },
      375: { full: 94, mix: 48 },
      400: { full: 100, mix: 51 },
      425: { full: 106, mix: 54 },
      450: { full: 111, mix: 56 },
      475: { full: 117, mix: 59 },
      500: { full: 123, mix: 62 },
      525: { full: 128, mix: 65 },
      550: { full: 134, mix: 68 },
      575: { full: 139, mix: 70 },
      600: { full: 145, mix: 73 },
      625: { full: 151, mix: 76 },
      650: { full: 156, mix: 79 },
      675: { full: 162, mix: 82 },
      700: { full: 168, mix: 85 },
      725: { full: 173, mix: 87 },
      750: { full: 179, mix: 90 },
      775: { full: 184, mix: 93 },
      800: { full: 190, mix: 96 },
      825: { full: 196, mix: 99 },
      850: { full: 201, mix: 101 },
      875: { full: 207, mix: 104 },
      900: { full: 213, mix: 107 },
      925: { full: 218, mix: 110 },
      950: { full: 224, mix: 113 },
      975: { full: 229, mix: 115 },
      1000: { full: 235, mix: 118 },
      1025: { full: 241, mix: 121 },
      1050: { full: 246, mix: 124 },
      1075: { full: 252, mix: 127 },
      1100: { full: 258, mix: 130 },
      1125: { full: 263, mix: 132 },
      1150: { full: 269, mix: 135 },
      1175: { full: 274, mix: 138 },
      1200: { full: 280, mix: 141 },
      1225: { full: 286, mix: 144 },
      1250: { full: 291, mix: 146 },
      1275: { full: 297, mix: 149 },
      1300: { full: 303, mix: 152 },
      1325: { full: 308, mix: 155 },
      1350: { full: 314, mix: 158 },
      1375: { full: 319, mix: 160 },
      1400: { full: 325, mix: 163 },
      1425: { full: 331, mix: 166 },
      1450: { full: 336, mix: 169 },
      1475: { full: 342, mix: 172 },
      1500: { full: 348, mix: 175 }
    },
    'cat-raw': {
      90: { full: 28, mix: 15 },
      100: { full: 33, mix: 17 },
      120: { full: 36, mix: 19 },
      150: { full: 42, mix: 22 },
      175: { full: 48, mix: 25 },
      200: { full: 54, mix: 28 },
      225: { full: 59, mix: 30 },
      250: { full: 63, mix: 32 },
      275: { full: 67, mix: 34 }
    },
    'cat-cooked': {
      90: { full: 31, mix: 17 },
      100: { full: 35, mix: 18 },
      120: { full: 38, mix: 20 },
      150: { full: 45, mix: 23 },
      175: { full: 51, mix: 26 },
      200: { full: 57, mix: 29 },
      225: { full: 61, mix: 31 },
      250: { full: 66, mix: 34 },
      275: { full: 72, mix: 37 }
    }
  };

  var REVIEWED_SIZES = {};
  Object.keys(OWNER_PRICES).forEach(function (categoryId) {
    REVIEWED_SIZES[categoryId] = Object.keys(OWNER_PRICES[categoryId]).map(Number).sort(function (a, b) {
      return a - b;
    });
  });

  function roundPortionUp(portionGrams) {
    var portion = assertFinitePositive(portionGrams, 'Portion');
    return Math.ceil(Number(portion.toFixed(9)) / PORTION_INCREMENT_GRAMS) * PORTION_INCREMENT_GRAMS;
  }

  function packagePortion(portionGrams) {
    return Math.max(MINIMUM_PACKAGE_GRAMS, roundPortionUp(portionGrams));
  }

  function assertFinitePositive(value, field) {
    var number = Number(value);
    if (!Number.isFinite(number) || number <= 0) {
      throw new Error(field + ' must be a positive number.');
    }
    return number;
  }

  function normalizeSpecies(species) {
    var normalized = String(species || '').toLowerCase();
    if (normalized !== 'dog' && normalized !== 'cat') {
      throw new Error('Species must be dog or cat.');
    }
    return normalized;
  }

  function normalizeAgeInMonths(ageValue, ageUnit) {
    var age = assertFinitePositive(ageValue, 'Age');
    return ageUnit === 'months' ? age : age * 12;
  }

  function normalizeSplitAgeInMonths(ageYears, ageMonths) {
    var years = Number(ageYears);
    var months = ageMonths === null || typeof ageMonths === 'undefined' || ageMonths === ''
      ? 0
      : Number(ageMonths);

    if (!Number.isFinite(years) || !Number.isInteger(years) || years < 0) {
      throw new Error('Age in years must be a whole number of 0 or more.');
    }

    if (!Number.isFinite(months) || !Number.isInteger(months) || months < 0 || months > 11) {
      throw new Error('Age in months must be a whole number from 0 to 11.');
    }

    return years * 12 + months;
  }

  function catPortion(weightKg) {
    if (weightKg < 2) return 90;
    if (weightKg < 2.5) return 100;
    if (weightKg < 3) return 120;
    if (weightKg < 3.5) return 150;
    if (weightKg < 4) return 175;
    if (weightKg < 5) return 200;
    if (weightKg < 6) return 225;
    if (weightKg < 7) return 250;
    if (weightKg <= 8) return 275;
    return 275;
  }

  function dogPortion(weightKg, activity, bodyCondition) {
    var activityKey = String(activity || '').toLowerCase();
    var factors = DOG_FACTORS[activityKey];
    if (!factors) {
      throw new Error('Activity must be low, moderate, or high for a dog.');
    }

    var sizeFactor = weightKg <= 10 ? factors.small : factors.large;
    var adjustment = CONDITION_ADJUSTMENTS[bodyCondition || 'unsure'];
    if (typeof adjustment === 'undefined') adjustment = 0;

    var standardBand = weightKg >= 10 && weightKg <= 12 && activityKey === 'moderate' && adjustment === 0;
    return standardBand ? 300 : weightKg * (sizeFactor + adjustment) * 1000;
  }

  function roundFullPlan(rawPrice) {
    return Math.floor(Number(rawPrice) + 0.5);
  }

  function nextWholeJod(value) {
    return Math.floor(Number(value)) + 1;
  }

  function fullPrice(portionGrams, rate) {
    return roundFullPlan((packagePortion(portionGrams) / 1000) * 30 * Number(rate) + 10);
  }

  function pricesForPortion(portionGrams, rate) {
    var full = fullPrice(portionGrams, rate);
    var mix = nextWholeJod(full * 0.5);
    var trial = nextWholeJod(mix * 0.5);

    return {
      full: full,
      mix: mix,
      trial: trial,
      custom: full
    };
  }

  function categoryAvailable(categoryId, portionGrams) {
    return categoryId !== 'dog-raw-budget' || packagePortion(portionGrams) >= MINIMUM_BUDGET_PACKAGE_GRAMS;
  }

  function reviewedPlanPrice(packageGrams, categoryId, plan, formulaPrice) {
    // Exact owner correction (21 Oct 2026), not a new interpolation anchor:
    // changing the historical 350 g anchor would alter eight nearby portions.
    if (categoryId === 'dog-raw-top' && packageGrams === 350 && plan === 'full') return 79;
    if (categoryId === 'dog-raw-top' && packageGrams === 355 && plan === 'full') return 79.5;
    var reviewed = OWNER_PRICES[categoryId];
    var sizes = REVIEWED_SIZES[categoryId];
    if (!sizes || !sizes.length) return formulaPrice;
    if (reviewed[packageGrams]) return reviewed[packageGrams][plan];
    if (packageGrams < sizes[0]) return reviewed[sizes[0]][plan];

    for (var index = 1; index < sizes.length; index += 1) {
      var upperGrams = sizes[index];
      if (packageGrams < upperGrams) {
        var lowerGrams = sizes[index - 1];
        var lowerPrice = reviewed[lowerGrams][plan];
        var upperPrice = reviewed[upperGrams][plan];
        var progress = (packageGrams - lowerGrams) / (upperGrams - lowerGrams);
        return Math.ceil(Number((lowerPrice + progress * (upperPrice - lowerPrice)).toFixed(9)));
      }
    }

    return Math.max(reviewed[sizes[sizes.length - 1]][plan], formulaPrice);
  }

  function categoryPrices(portionGrams, category) {
    if (!categoryAvailable(category.id, portionGrams)) return null;
    var packageGrams = packagePortion(portionGrams);
    var prices = pricesForPortion(portionGrams, category.rate);
    prices.full = reviewedPlanPrice(packageGrams, category.id, 'full', prices.full);
    prices.mix = reviewedPlanPrice(packageGrams, category.id, 'mix', prices.mix);
    prices.trial = nextWholeJod(prices.mix * 0.5);
    prices.custom = prices.full;
    return prices;
  }

  function discountForPetPosition() {
    return 0;
  }

  function applyPetDiscount(price, position) {
    var discount = discountForPetPosition(position);
    return Number((Number(price) * (1 - discount)).toFixed(2));
  }

  function checkoutVariant(catalog, categoryId, priceJod) {
    if (!catalog || catalog.categoryId !== categoryId || catalog.currency !== 'JOD') return null;
    if (catalog.checkoutEnabled !== true || !['ACTIVE', 'UNLISTED'].includes(catalog.status)) return null;
    var price = Number(priceJod);
    if (!Number.isFinite(price) || price <= 0) return null;
    var key = price.toFixed(2);
    if (Math.abs(price - Number(key)) > 0.000000001) return null;
    var id = catalog.prices && catalog.prices[key];
    if (!/^\d+$/.test(String(id)) || !Number.isSafeInteger(Number(id)) || Number(id) <= 0) return null;
    return { id: String(id), priceJod: Number(key) };
  }

  function calculate(input) {
    var species = normalizeSpecies(input.species);
    var weightKg = assertFinitePositive(input.weightKg, 'Weight');
    var hasSplitAge = Object.prototype.hasOwnProperty.call(input, 'ageYears') || Object.prototype.hasOwnProperty.call(input, 'ageMonths');
    var ageMonths = hasSplitAge
      ? normalizeSplitAgeInMonths(input.ageYears, input.ageMonths)
      : normalizeAgeInMonths(input.ageValue, input.ageUnit);
    var bodyCondition = String(input.bodyCondition || 'unsure').toLowerCase();
    var calculatedPortion = species === 'dog'
      ? dogPortion(weightKg, input.activity, bodyCondition)
      : catPortion(weightKg);
    var recommendedPortion = roundPortionUp(calculatedPortion);

    var customPortion = input.customPortionGrams
      ? assertFinitePositive(input.customPortionGrams, 'Custom portion')
      : null;
    var selectedPortion = customPortion ? roundPortionUp(customPortion) : recommendedPortion;
    var pricedPortion = packagePortion(selectedPortion);
    var belowMinimumPackage = (customPortion || calculatedPortion) < MINIMUM_PACKAGE_GRAMS;
    var reviewReasons = [];

    if (ageMonths < 12) reviewReasons.push(species === 'dog' ? 'puppy' : 'kitten');
    if (species === 'dog' && (weightKg < 1 || weightKg > 60)) reviewReasons.push('weight-range');
    if (species === 'cat' && (weightKg < 2 || weightKg > 8)) reviewReasons.push('weight-range');
    if (input.hasHealthNeeds === true) reviewReasons.push('health-needs');
    if (input.hasDietaryRestrictions === true) reviewReasons.push('dietary-restrictions');
    if (calculatedPortion < MINIMUM_PACKAGE_GRAMS || belowMinimumPackage) reviewReasons.push('small-portion');

    var petPosition = Math.max(1, Math.floor(Number(input.petPosition) || 1));
    var categories = CATEGORY_RATES[species].filter(function (category) {
      return categoryAvailable(category.id, selectedPortion);
    }).map(function (category) {
      var recommendedPrices = categoryPrices(recommendedPortion, category);
      var customPrices = customPortion ? categoryPrices(customPortion, category) : null;
      var selectedPrices = customPrices || recommendedPrices;
      var discounted = {};

      Object.keys(selectedPrices).forEach(function (plan) {
        discounted[plan] = applyPetDiscount(selectedPrices[plan], petPosition);
      });

      return {
        id: category.id,
        name: category.name,
        rate: category.rate,
        recommendedPrices: recommendedPrices,
        customPrices: customPrices,
        selectedPrices: selectedPrices,
        discountedPrices: discounted
      };
    });

    return {
      species: species,
      ageMonths: ageMonths,
      weightKg: weightKg,
      weightGrams: Math.round(weightKg * 1000),
      calculatedPortionGrams: Number(calculatedPortion.toFixed(3)),
      recommendedPortionGrams: Number(recommendedPortion.toFixed(3)),
      displayRecommendedPortionGrams: Math.round(recommendedPortion),
      selectedPortionGrams: selectedPortion,
      displaySelectedPortionGrams: selectedPortion,
      packagePortionGrams: pricedPortion,
      minimumPackageGrams: MINIMUM_PACKAGE_GRAMS,
      belowMinimumPackage: belowMinimumPackage,
      usesCustomPortion: Boolean(customPortion),
      needsManualReview: reviewReasons.length > 0,
      reviewReasons: reviewReasons,
      petPosition: petPosition,
      discountRate: discountForPetPosition(petPosition),
      packaging: pricedPortion <= 250 ? 'plastic-packet' : 'vacuum-bag',
      categories: categories
    };
  }

  return {
    CATEGORY_RATES: CATEGORY_RATES,
    DOG_FACTORS: DOG_FACTORS,
    PORTION_INCREMENT_GRAMS: PORTION_INCREMENT_GRAMS,
    MINIMUM_PACKAGE_GRAMS: MINIMUM_PACKAGE_GRAMS,
    MINIMUM_BUDGET_PACKAGE_GRAMS: MINIMUM_BUDGET_PACKAGE_GRAMS,
    OWNER_PRICES: OWNER_PRICES,
    roundPortionUp: roundPortionUp,
    packagePortion: packagePortion,
    calculate: calculate,
    catPortion: catPortion,
    dogPortion: dogPortion,
    fullPrice: fullPrice,
    pricesForPortion: pricesForPortion,
    categoryPrices: categoryPrices,
    categoryAvailable: categoryAvailable,
    checkoutVariant: checkoutVariant,
    discountForPetPosition: discountForPetPosition,
    applyPetDiscount: applyPetDiscount
  };
});
